/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { CardIcon } from "../../../../ui/components/Card/CardIcon";
import { Icon, ICON_SIZE } from "../../../../ui/components/Icon";
import { CardText } from "../../../../ui/components/Card/CardText";
import { Card } from "../../../../ui/components/Card/Card";
import { CardContent } from "../../../../ui/components/Card/CardContent";

export interface IIntegrationEditorCreateListItemProps {
	className?: string;
	icon?: string;
	label?: string;
	description?: string;
	onClick?: () => void;
	selected?: boolean;
}

export const IntegrationEditorCreateListItem: React.FC<IIntegrationEditorCreateListItemProps> = ({
	className,
	icon,
	label,
	description,
	onClick,
	selected
}) => {
	const baseClass = BEM("edt-integration-editor-create-list-item", null, {
		selected
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<Card className={baseClass.toClassName()} onClick={onClick} button>
			<CardContent>
				{selected && (
					<div className={baseClass.element("check").toClassName()}>
						<Icon name="mdi/check-circle" size={ICON_SIZE.SMALL} />
					</div>
				)}
				<CardIcon>{icon && <Icon name={icon} size={ICON_SIZE.LARGE} />}</CardIcon>
				<CardText primary={label} secondary={description} />
			</CardContent>
		</Card>
	);
};
